import { AxiosAdapter } from '../../../_config/adapters/axios/axios.adapter';
import { Http } from '../../../_config/adapters/axios/axios.protocols';
import { Enviroment } from '../../../_config/constants/enviroment-v2.constant';

export class Service {
	async getAll(page, name_local, pharmacy) {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.FUNCTION_MIGRATION_PHAROL}/pharmacy-locals/country/${Enviroment.LANGUAGE}/page/${page}`,
			params: { name_local, pharmacy },
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}

	async getById(id) {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.FUNCTION_MIGRATION_PHAROL}/pharmacy-locals/${id}`,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}

	async getByNameLocal(nameLocal, page) {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.FUNCTION_MIGRATION_PHAROL}/pharmacy-locals/name-local/${nameLocal}/page/${page}`,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}

	async create(body) {
		return new AxiosAdapter({
			method: Http.POST,
			url: `${Enviroment.FUNCTION_MIGRATION_PHAROL}/pharmacy-locals/`,
			data: body,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}

	async updateById(id, body) {
		return new AxiosAdapter({
			method: Http.PUT,
			url: `${Enviroment.FUNCTION_MIGRATION_PHAROL}/pharmacy-locals/${id}`,
			data: body,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}

	async deleteById(id) {
		return new AxiosAdapter({
			method: Http.DELETE,
			url: `${Enviroment.FUNCTION_MIGRATION_PHAROL}/pharmacy-locals/${id}`,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}

	async getBrandsByCountry() {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.FUNCTION_MIGRATION_PHAROL}/pharmacy-locals/brand/country/${Enviroment.LANGUAGE}`,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}

	async getRegionsByCountry() {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.FUNCTION_MIGRATION_PHAROL}/place/country/${Enviroment.LANGUAGE}`,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}

	async getCommunesByRegion(region) {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.FUNCTION_MIGRATION_PHAROL}/place/country/${Enviroment.LANGUAGE}/region/${region}`,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}

	async getPharmacieMP(pharmacy) {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.MERCADO_PAGO_AR}/token-pharmacy/${pharmacy}`,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}

	async getSpecialSchedule(id) {
		return new AxiosAdapter({
		  method: Http.GET,
		  url: `${Enviroment.FUNCTION_MIGRATION_PHAROL}/pharmacy-locals/get-special-schedule/${id}`,
		})
		  .request()
		  .then((response) => response)
		  .catch((e) => {
			throw e;
		  });
	  }

	async deleteSpecialSchedule(localId, specialScheduleId) {
		return new AxiosAdapter({
			method: Http.PUT,   
			url: `${Enviroment.FUNCTION_MIGRATION_PHAROL}/pharmacy-locals/delete-special-schedule`,
			data: {
					local_id: localId,
					special_schedule_id: specialScheduleId,
			},
		})
			.request()
			.then((response) => response)   
			.catch((e) => { throw e; });
	}

	async createSpecialSchedule(payload) {
		return new AxiosAdapter({
		  method: Http.PUT,
		  url: `${Enviroment.FUNCTION_MIGRATION_PHAROL}/pharmacy-locals/create-special-schedule`,
		  data: payload,
		})
		  .request()
		  .then((response) => response)          
		  .catch((e) => { throw e; });
	  }
  

	  
}
